function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.2537C0 14.7832 2.86504 18.6266 6.83876 19.9824C7.33908 20.0768 7.52141 19.7602 7.52141 19.4883C7.52141 19.2447 7.51281 18.6002 7.5079 17.7447C4.72636 18.3641 4.13948 16.37 4.13948 16.37C3.68458 15.1854 3.02894 14.8701 3.02894 14.8701C2.121 14.2337 3.0977 14.2469 3.0977 14.2469C4.10142 14.3193 4.62936 15.3038 4.62936 15.3038C5.52196 16.8704 6.97013 16.4179 7.53983 16.1554C7.63068 15.4926 7.88913 15.0413 8.17459 14.7845C5.95414 14.5258 3.61951 13.6464 3.61951 9.71741C3.61951 8.59762 4.00933 7.6824 4.64901 6.96546C4.54649 6.70613 4.20332 5.66377 4.74723 4.25255C4.74723 4.25255 5.58703 3.97622 7.49685 5.30309C8.29491 5.07586 9.15007 4.96193 10.0003 4.95816C10.8499 4.96193 11.7051 5.07586 12.5044 5.30309C14.413 3.97622 15.2515 4.25255 15.2515 4.25255C15.7967 5.66377 15.4535 6.70613 15.351 6.96546C15.9919 7.6824 16.3786 8.59762 16.3786 9.71741C16.3786 13.6559 14.0409 14.5226 11.8131 14.7769C12.1723 15.0935 12.4915 15.7192 12.4915 16.6753C12.4915 18.0463 12.4798 19.1522 12.4798 19.4883C12.4798 19.7628 12.6597 20.0813 13.1674 19.9812C17.1374 18.6228 20 14.7826 20 10.2537C20 4.59056 15.5223 0 9.99908 0C4.47773 0 0 4.59056 0 10.2537Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.4927f1a2b31261f4dc4e719450f01472.svg";
export { ForwardRef as ReactComponent };